import { useState, useContext, useEffect } from 'react';
import { ClientContext } from '../../../../contexts/clientProvider';
import { UserContext } from '../../../../contexts/userProvider';

const Observacoes = ({ client, setClient, handleFecharClick }) => {
  const { updateCliente } = useContext(ClientContext);
  const { isGerente } = useContext(UserContext);
  const [type, setType] = useState('Geral');
  const [editedData, setEditedData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setEditedData(client);
  }, [client]);

  const handleEditClick = () => {
    setType('Edit');
    setEditedData(client);
  };

  const handleSaveClick = async () => {
    setLoading(true);
    const newClient = await updateCliente(editedData);
    setClient(newClient);
    setType('Geral');
    setLoading(false);
    handleFecharClick();
  };

  const handleCancelClick = () => {
    setType('Geral');
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedData((prevData) => ({ ...prevData, [name]: value }));
  };

  return (
    <div className="space-y-6">
      {/* Conteúdo principal */}
      <div className="bg-white dark:bg-gray-800 rounded-lg p-6 shadow-sm border border-gray-200 dark:border-gray-700">
        {type === 'Geral' ? (
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <span className="text-2xl">📝</span>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                Observações
              </h2>
            </div>
            <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4 min-h-32 border border-gray-200 dark:border-gray-600">
              <p className="text-gray-900 dark:text-gray-100 whitespace-pre-line leading-relaxed">
                {client?.observacoes || 'Nenhuma observação cadastrada.'}
              </p>
            </div>
          </div>
        ) : (
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <span className="text-2xl">✏️</span>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                Editar Observações
              </h2>
            </div>
            <textarea
              id='observacoes'
              name='observacoes'
              value={editedData.observacoes || ''}
              onChange={handleInputChange}
              rows={8}
              className="w-full min-h-32 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 p-4 text-base resize-vertical focus:ring-2 focus:ring-vox-blue-500 focus:border-vox-blue-500 transition-colors duration-200"
              placeholder='Digite observações relevantes sobre o cliente...'
            />
          </div>
        )}
      </div>

      {/* Botões de ação */}
      <div className="flex flex-col sm:flex-row gap-3 pt-6 border-t border-gray-200 dark:border-gray-700">
        {type === 'Geral' ? (
          <>
            <button 
              onClick={handleFecharClick}
              className="flex-1 sm:flex-none px-6 py-3 bg-gray-500 hover:bg-gray-600 text-white font-medium rounded-lg transition-colors duration-200 flex items-center justify-center"
            >
              <span className="mr-2">✕</span>
              Fechar
            </button>
            {isGerente && (
            <button 
              onClick={handleEditClick}
              className="flex-1 sm:flex-none px-6 py-3 bg-vox-blue-600 hover:bg-vox-blue-700 text-white font-medium rounded-lg transition-colors duration-200 flex items-center justify-center"
            >
              <span className="mr-2">✏️</span>
              Editar
            </button>
            )}
          </>
        ) : (
          <>
            <button 
              onClick={handleCancelClick}
              className="flex-1 sm:flex-none px-6 py-3 bg-gray-500 hover:bg-gray-600 text-white font-medium rounded-lg transition-colors duration-200 flex items-center justify-center"
            >
              <span className="mr-2">✕</span>
              Cancelar
            </button>
            <button 
              onClick={handleSaveClick}
              disabled={loading}
              className="flex-1 sm:flex-none px-6 py-3 bg-vox-green-600 hover:bg-vox-green-700 disabled:bg-gray-400 text-white font-medium rounded-lg transition-colors duration-200 flex items-center justify-center"
            >
              {loading ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                  Salvando...
                </>
              ) : (
                <>
                  <span className="mr-2">💾</span>
                  Salvar
                </>
              )}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default Observacoes; 